import { createTheme } from '@mui/material';

import { darkThemeOptions, defaultThemeOptions, lightThemeOptions } from './defaultThemeConfig';

const defaultLightTheme = createTheme(lightThemeOptions, defaultThemeOptions);
const defaultDarkTheme = createTheme(darkThemeOptions, defaultThemeOptions);

export { defaultLightTheme, defaultDarkTheme };
